import { __spreadArray, __read } from 'tslib';
import { AvailableCountries } from '@invitae/location-lite-react';
import { AVAILABLE_COUNTRIES, pathsWithoutCountryCode } from './setup.esm.js';

var allCountryPrefixes = AVAILABLE_COUNTRIES.map(function (country) { return country.toLowerCase(); });
var sanitizePath = function (path) {
    if (path.startsWith('https://') || path.startsWith('http://')) {
        var regex = /http(s?):\/\/(?:www\.)?([a-z0-9-]+)(?:\.[a-z.]+)?/;
        return path.replace(regex, '');
    }
    return path;
};
/**
 * Regex to get prefixes from url
 * Eg: '/us/cancer' -> '/us/', '/fr-CA/providers' -> '/fr-CA/'
 */
var CREATE_PREFIX_REGEX = function (additionalPrefixes) {
    if (additionalPrefixes === void 0) { additionalPrefixes = ''; }
    var regex = additionalPrefixes
        ? "^(/?(([a-zA-Z]{2}(-[A-Z]{2})?)|".concat(additionalPrefixes, "))($|/|\\?(.*))")
        : "^(/?([a-zA-Z]{2}(-[A-Z]{2})?))($|/|\\?(.*))";
    return new RegExp(regex);
};
/**
 * verify if current path already has a prefix
 */
var alreadyHasPrefix = function (path) {
    var allPrefixes = __spreadArray(__spreadArray([], __read(allCountryPrefixes), false), __read(pathsWithoutCountryCode), false).join('|');
    var regex = CREATE_PREFIX_REGEX(allPrefixes);
    return regex.test(path);
};
/**
 * Add country code to the path
 * Eg: addCountryCodeToPath('US', '/pregnancy') -> '/us/pregnancy'
 */
var addCountryCodeToPath = function (countryCode, pathname) {
    var path = pathname.trim();
    // verify if path is external link
    if (path.startsWith('https://') || path.startsWith('http://'))
        return path;
    /**
     * paths using # at the begining means the path is internal and doesn't need country code or anything
     */
    if (path.startsWith('#'))
        return path;
    var prefix = "/".concat(countryCode.toLowerCase());
    var pathWithSlash = path.startsWith('/') ? path : "/".concat(path);
    var updatedPath = pathWithSlash === '/' ? '' : pathWithSlash;
    return alreadyHasPrefix(updatedPath) ? updatedPath : "".concat(prefix).concat(updatedPath);
};
/**
 * countryCodeIndicatorFromPath it's a function that identify the prefix on the URL and returns it and the rest of the url without prefix
 * Eg: '/au/providers' -> ['au', 'providers']
 */
var countryCodeIndicatorFromPath = function (path) {
    var _a;
    var regex = CREATE_PREFIX_REGEX();
    var pathname = sanitizePath(path);
    var countryCode = (_a = pathname.match(regex)) === null || _a === void 0 ? void 0 : _a[0].replaceAll('/', '');
    var currentPath = pathname.replace(regex, '');
    var result = [countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase(), currentPath || '/'];
    return result;
};
/**
 * Returns if the prefix is a valid country from location-lite
 * Eg:
 * - isValidPrefix('zz') -> false
 * - isValidPrefix('us') -> true
 */
var isValidPrefix = function (prefix) {
    var regex = new RegExp("^(".concat(AvailableCountries.join('|'), ")$"), 'i');
    return regex.test(prefix);
};

export { CREATE_PREFIX_REGEX, addCountryCodeToPath, allCountryPrefixes, alreadyHasPrefix, countryCodeIndicatorFromPath, isValidPrefix, sanitizePath };
//# sourceMappingURL=utils.esm.js.map
